import { makeStyles } from '@material-ui/core';
import { rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../mui-theme';

const tabFontSize = {
  '@media (max-height: 768px)': {
    fontSize: rem(0.75),
  },
  '@media (max-height: 576px)': {
    fontSize: rem(0.625),
  },
};

export const styles = makeStyles(theme => ({
  cashierPreferencesContainer: {
    backgroundColor: themeColor.lightBackground,
    padding: `3.1901vh 1.9531vw 2.474vh`,
  },
  cashierPreferencesContainerInner: {
    backgroundColor: themeColor.white,
    border: `1px solid ${themeColor.lightgrey}`,
    maxWidth: '89.845vw',
    alignSelf: 'center',
  },
  cashierPreferencesTitleContainer: {
    flex: '0 0 auto',
    maxHeight: 'fit-content',
  },
  cashierPreferencesTitleBarContainer: {
    paddingBottom: '5.795vh',
    flex: '0 0 auto',
  },
  cashierPreferencesTitleHeader: {
    color: themeColor.defaultTextColor,
  },
  cashierPreferencesTitleHeaderLabel: {
    fontSize: vh(4.18),
    fontWeight: 500,
    lineHeight1: 1.33,
  },
  cashierPreferencesContentContainer: {
    paddingTop: `3.7vh`,
    alignItems: 'center',
  },
  cashierPreferencesColorBlindnessContentContainer: {
    padding: '.75vh 4.5vw',
    alignItems: 'center',
  },
  cashierPreferencesBar: {
    width: '4vw',
    height: '.653vh',
    backgroundColor: theme.palette.secondary.main,
  },
  cashierPreferencesButtonContainer: {
    backgroundColor: themeColor.lightBackground,
  },
  customTabs: {
    border: `1px solid ${themeColor.lightgray}`,
    height: '100%',
    backgroundColor: themeColor.white,
    justifyContent: 'center',
    minHeight: '0',
  },
  tab: {
    minWidth: '13.34vw',
    maxWidth: 'fit-content',
    padding: '0 1.953vw',
    height: '7.292vh',
    minHeight: '0',
    '& span': {
      fontSize: vh(1.825),
      lineHeight: '2.086vh',
      fontWeight: 'bold',
      color: theme.palette.info.dark,
      '& svg': {
        color: theme.palette.info.main,
        fill: theme.palette.info.main,
        fontSize: vh(2.86),
      },
    },
    '&.Mui-selected': {
      '& span': {
        color: themeColor.blackpearl,
        '& svg': {
          color: theme.palette.secondary.main,
          fill: theme.palette.secondary.main,
        },
      },
    },
    '& svg': {
      width: '2.86vh',
      height: '2.86vh',
    },
    '&:nth-child(-n+2)': {
      marginRight: '.9766vw',
    },
  },
  cashierPreferencesOptionRadioButtonContainer: {
    paddingTop: '3vh',
    justifyContent: 'center',
  },
  cashierPreferencesColorBlindnessOptionRadioButtonContainer: {
    paddingTop: '.75vh',
    justifyContent: 'center',
  },
  cashierPreferencesOptionRadioButton: {
    fontSize: rem(1.13),
    letterSpacing: '1.43px',
    ...tabFontSize,
  },
  cashierPreferencesOptionRadioButtonIcon: {
    paddingLeft: '10px',
  },
  optionsContainer: {
    textAlign: 'center',
  },
  dominantOptionsContainer: {
    textAlign: 'center',
    paddingBottom: '4.297vh',
    paddingLeft: '1.27vw',
    paddingRight: '1.27vw',
    paddingTop: '3.5916vh',
  },
  dominantHandImages: {
    maxWidth: '38vw',
    maxHeight: '38vh',
    border: `1px solid ${themeColor.lightgrey}`,
  },
  colorBlindnessImages: {
    maxWidth: '26vw',
    maxHeight: '25.9vh',
    border: `solid 1px ${themeColor.blackish}`,
    '@media (height: 576px)': {
      maxHeight: '20vh',
    },
  },
  cashierPreferencesTabContainer: {
    height: '7.292vh',
    maxWidth: '89.845vw',
    alignSelf: 'center',
  },
  selectedContainer: {
    backgroundColor: themeColor.lightgrey,
    border: `3px solid ${themeColor.secondaryMain}`,
  },
  dominantHandUnSelectedContainer: {
    border: `3px solid ${themeColor.white}`,
  },
  dominantHandImageButton: {
    width: `100%`,
  },
}));
